<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 50px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addServiceUser()">新建</el-button>&nbsp;
        <el-button type="warning" plain icon="el-icon-refresh" @click="openBatchReplace()">批量替换服务人员服务单</el-button>&nbsp;
        <el-input
          prefix-icon="el-icon-search"
          placeholder="输入姓名搜索"
          v-model="searchKeyword"
          clearable
          style="width: 300px"
        >
        </el-input>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto">
        <el-table
          v-loading="loading"
          element-loading-text="数庞大，请耐心等待"
          :data="tbdata"
          border
          style="width: 100%"
          highlight-current-row
          ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
          align="center">
          </el-table-column>
          <el-table-column
            prop="jobnum"
            label="工号"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            min-width="110"
            align="center">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="所属服务商"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span>{{getOnSuppOrg(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            label="录入时间"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editServiceUser(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delServiceUser(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <!--created update-->
    <el-dialog
      :visible.sync="addEditShow"
      v-if="addEditShow"
      width="500px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{openTitle}}</span> </div>
        <div class="line-title"></div>
      </div>
      <add-edit-sperson :addEdit="addEditObj" v-model="addEditShow"></add-edit-sperson>
    </el-dialog>

    <!-- 批量替换服务人员 dialog -->
    <el-dialog
      :visible.sync="batchReplaceShow"
      v-if="batchReplaceShow"
      width="600px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      class="all-open">
      <div class="title-top-alarm">
        <div><span>批量替换服务人员服务单</span></div>
        <div class="line-title"></div>
      </div>
      <div style="margin: 20px 30px 0">
        <el-form :model="batchForm" :rules="batchRules" ref="batchForm" label-width="120px">
          <el-form-item label="离职人员" prop="old_supplier_person_id">
            <el-select v-fixZoom filterable v-model="batchForm.old_supplier_person_id" placeholder="请选择离职人员" style="width: 100%">
              <el-option v-for="item in tableData" :key="item.id" :label="item.name + (item.jobnum ? '（' + item.jobnum + '）' : '')" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接替人员" prop="new_supplier_person_id">
            <el-select v-fixZoom filterable v-model="batchForm.new_supplier_person_id" placeholder="请选择接替人员" style="width: 100%" @change="onNewPersonChange">
              <el-option v-for="item in tableData" :key="item.id" :label="item.name + (item.jobnum ? '（' + item.jobnum + '）' : '')" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="替换开始时间">
            <el-date-picker
              v-model="batchForm.start_time"
              type="datetime"
              placeholder="不选则替换所有服务单"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%">
            </el-date-picker>
            <div style="font-size: 12px;color: #909399;margin-top: 4px">建议填写离职日期，只替换该时间之后的服务单，保留历史记录</div>
          </el-form-item>
        </el-form>

        <!-- 替换结果展示 -->
        <el-alert
          v-if="batchResult"
          :title="batchResult.title"
          :type="batchResult.type"
          :description="batchResult.desc"
          show-icon
          :closable="false"
          style="margin-bottom: 10px">
        </el-alert>

        <el-row style="margin: 20px 0 0">
          <el-col :span="12">
            <div class="cancel-btn" @click="batchReplaceShow = false"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitBatchReplace"><span>开始替换</span></div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 20px"></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  querysupplierorgperson,
  deletesupplierorgperson,
  querysupplierorgnotype,
  batchreplacesupplierperson
} from '../../api/serviceMark'
import addEditSperson from './childComponents/addEditSperson'
export default {
  name: 'serviceUser',
  components: {addEditSperson},
  data () {
    return {
      searchKeyword: '',
      supplierorg: [],
      tableData: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      openTitle: '',
      addEditShow: false,
      addEditObj: {
        isAdd: true,
        row: {},
        supplierorg: []
      },
      // 批量替换
      batchReplaceShow: false,
      batchReplaceLoading: false,
      batchResult: null,
      batchForm: {
        old_supplier_person_id: '',
        new_supplier_person_id: '',
        new_supplier_person_name: '',
        start_time: ''
      },
      batchRules: {
        old_supplier_person_id: [{ required: true, message: '请选择离职人员', trigger: 'change' }],
        new_supplier_person_id: [{ required: true, message: '请选择接替人员', trigger: 'change' }]
      }
    }
  },
  created () {
    this.golobleObject.updateTableSuser = this.querySupplierPerson
    this.querySupplier()
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    querySupplier () {
      this.loading = true
      let params = { page: 1, size: 9999 }
      querysupplierorgnotype(params).then(res => {
        this.supplierorg = res.data.org
        this.addEditObj.supplierorg = this.supplierorg
        this.querySupplierPerson()
      }).catch(() => {
        this.loading = false
      })
    },
    querySupplierPerson () {
      querysupplierorgperson().then(res => {
        this.loading = false
        let isTime = res.data.supplierorgpersons.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        this.tableData = res.data.supplierorgpersons
      }).catch(() => {
        this.loading = false
      })
    },
    getOnSuppOrg (row) {
      for (let i = 0; i < this.supplierorg.length; i++) {
        if (row.soid === this.supplierorg[i].id) {
          return this.supplierorg[i].name
        }
      }
    },
    searchFilterWord () {
      const data = this.tableData
      const vm = this
      const search = data.filter((val) => {
        if (val.name.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) break
        arr.push(search[i])
      }
      return arr
    },
    addServiceUser () {
      this.openTitle = '新建服务商人员'
      this.addEditObj.isAdd = true
      this.addEditObj.row = {}
      this.addEditShow = true
    },
    editServiceUser (row) {
      this.openTitle = '更新服务商人员'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delServiceUser (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该服务商人员【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = { sopids: [row.id] }
        deletesupplierorgperson(data).then(res => {
          this.$notify({ title: '成功', message: '删除服务商人员成功', type: 'success', duration: 2000 })
          this.querySupplierPerson()
        }).catch(() => {})
      }).catch(() => {})
    },
    // 批量替换
    openBatchReplace () {
      this.batchResult = null
      this.batchForm = {
        old_supplier_person_id: '',
        new_supplier_person_id: '',
        new_supplier_person_name: '',
        start_time: ''
      }
      this.batchReplaceShow = true
    },
    onNewPersonChange (val) {
      const person = this.tableData.find(p => p.id === val)
      if (person) {
        this.batchForm.new_supplier_person_name = person.name
      }
    },
    submitBatchReplace () {
      this.$refs['batchForm'].validate((valid) => {
        if (!valid) return false
        if (this.batchForm.old_supplier_person_id === this.batchForm.new_supplier_person_id) {
          this.$message.warning('离职人员与接替人员不能相同')
          return false
        }
        const oldPerson = this.tableData.find(p => p.id === this.batchForm.old_supplier_person_id)
        const newPerson = this.tableData.find(p => p.id === this.batchForm.new_supplier_person_id)
        const oldName = oldPerson ? oldPerson.name : ''
        const newName = newPerson ? newPerson.name : ''
        const timeText = this.batchForm.start_time ? this.batchForm.start_time + ' 之后' : '所有'
        this.$confirm(
          `确定将【${oldName}】的${timeText}服务单全部转给【${newName}】吗？此操作不可自动撤销。`,
          '确认批量替换',
          { confirmButtonText: '确定替换', cancelButtonText: '取消', type: 'warning' }
        ).then(() => {
          this.batchResult = null
          this.batchReplaceLoading = true
          const postData = {
            old_supplier_person_id: this.batchForm.old_supplier_person_id,
            new_supplier_person_id: this.batchForm.new_supplier_person_id,
            new_supplier_person_name: this.batchForm.new_supplier_person_name
          }
          if (this.batchForm.start_time) {
            postData.start_time = this.batchForm.start_time
          }
          batchreplacesupplierperson(postData).then(res => {
            this.batchReplaceLoading = false
            const d = res.data
            this.batchResult = {
              type: 'success',
              title: '替换成功',
              desc: `单次服务单：${d.single_count} 个  循环服务单：${d.cycle_count} 个  合计：${d.total_count} 个\n${d.message || ''}`
            }
            this.$notify({ title: '成功', message: `成功替换 ${d.total_count} 个服务单`, type: 'success', duration: 3000 })
          }).catch((err) => {
            this.batchReplaceLoading = false
            const msg = (err.response && err.response.data && err.response.data.msg) || '替换失败，请重试'
            this.batchResult = {
              type: 'error',
              title: '替换失败',
              desc: msg
            }
          })
        }).catch(() => {})
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/serviceUser.vue